<template>
  <div class="shelfEditButton">
    <el-button :disabled="showSaveButton" @click="saveData('goDetail')" class="goDetail">保存并预览{{ setType }}</el-button>
    <el-button :disabled="showSaveButton" @click="saveData('goList')" class="goList">保存并返回列表</el-button>
  </div>
</template>

<script>
export default {
  name: 'shelfLibButton',
  props: {
    setType: String,
    showSaveButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    saveData(payload) {
      this.$emit('saveDataCon', payload)
    }
  }
}
</script>

<style></style>
